import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './Style.module.css';

const LoaderOutletCard = ({ skeletonCount, customClass, hideSelectBtn = false }) => {
  const skeletonArray = Array.from({ length: skeletonCount });

  return (
      skeletonArray.map((_, index) => (
        <React.Fragment key={index}>
          <div className={`${styles.OutletCard} ${styles.skeleton} ${customClass}`}>
            <figure className={styles.left}>
              <Skeleton />
            </figure>
            <div className={styles.right}>
              <div className={styles.rightCard}>
                <div className={styles.detail}>
                  <h2><Skeleton /></h2>
                  <p><Skeleton /></p>
                </div>
                {!hideSelectBtn && (
                <div className={styles.ocSelect}>
                  <button>
                    <Skeleton />
                  </button>
                </div>
                )}
              </div>
            </div>
          </div>
          {index < skeletonArray.length - 1 && <hr className="line" />}
        </React.Fragment>
      ))
  );
};

export default LoaderOutletCard;
